var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttacksCampaigns = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.701 8.936 5.473 5.472 1.528-1.526L11.9 7.079a1.09 1.09 0 0 0-.796-.316l-3.525.104A1.08 1.08 0 0 0 6.53 7.915l-.104 3.526c-.009.297.105.585.315.795l5.804 5.803 1.527-1.527L8.6 11.039l.06-2.043zM25.032 29.076l.04-.037-.04.038zM28.74 25.37l-.039.039.037-.041z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.739 25.368-.038.04.04-.038zm-3.706 3.709.038-.038-.04.037h.002z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.175 27.804 28.74 25.37l-.04.039.037-.041.003.002 1.76-1.761a1.08 1.08 0 0 0 0-1.527L29.32 20.9a1.08 1.08 0 0 0-1.527 0l-1.036 1.036-2.37-2.37-1.526 1.527 2.37 2.37-2.104 2.103-2.37-2.37-1.527 1.527 2.37 2.37-1.036 1.036a1.08 1.08 0 0 0 0 1.528l1.182 1.18a1.076 1.076 0 0 0 1.527 0l1.76-1.76.04-.038-.04.038 2.436 2.435a1.08 1.08 0 0 0 1.526 0l2.18-2.18a1.08 1.08 0 0 0 0-1.528M28.23 29.22l-1.67-1.67.652-.652 1.67 1.67z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.568 26.329 14.857-14.857-.104-3.526-3.526-.104-14.857 14.857L9.139 20.9a1.08 1.08 0 0 0-1.528 0L6.43 22.082a1.08 1.08 0 0 0 0 1.528l1.76 1.76-2.433 2.435a1.08 1.08 0 0 0 0 1.528l2.18 2.179a1.076 1.076 0 0 0 1.526 0l2.435-2.434 1.76 1.76a1.076 1.076 0 0 0 1.526 0l1.182-1.181a1.08 1.08 0 0 0 0-1.528l-1.798-1.799zM8.7 29.219l-.653-.652 1.67-1.67.653.652z"
  })));
};
export default SvgAttacksCampaigns;